import HttpClient from "./httpClient";

class GuideApi extends HttpClient {
  public getGuides = (customerId?: string) =>
    this.get(
      "/guides",
      {},
      customerId && customerId !== "all" ? { customerId } : {}
    );

  public getGuideById = (id: string | number) => this.get(`/guides/${id}`, {});

  public addGuide = (guide: any) => this.post("/guides", {}, guide);

  public updateGuide = (guide: any) =>
    this.put(`/guides/${guide.id}`, {}, guide);

  public deleteGuide = (id: string | number) =>
    this.del(`/guides/${id}`, {});

  public getReindexStatus = (
    sourceDocType: "guide" | "kb" | "hudu_articles" | "itglue_docs" = "guide"
  ) => this.get("/reindex/status", {}, { source_doc_type: sourceDocType });

  public triggerReindex = (
    sourceDocType: "guide" | "kb" | "hudu_articles" | "itglue_docs" = "guide"
  ) => this.post("/reindex/trigger", {}, { source_doc_type: sourceDocType });
}

export default GuideApi;
